"use strict";
/**
 * @license
 * Copyright 2022 SOUTHWORKS UK LTD All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/southworks/codeverter/blob/main/LICENSE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Element = void 0;
const elements_1 = require("./types/elements");
class Element {
    constructor(params) {
        this.values = new elements_1.ElementValues();
        this.elementFactory = params.elementFactory;
    }
    addElementAndParse(kind, node) {
        let element = this.createElement(kind);
        element.parent = this;
        if (node) {
            element.parse(node);
        }
        this.values.add(kind, element);
    }
    getFactory(key) {
        return this.elementFactory[key];
    }
    getValues(kind) {
        return this.values.get(kind);
    }
    createElement(kind) {
        const factory = this.getFactory(kind);
        const created = new factory({
            sourceFile: this.getSourceFile(),
            typeChecker: this.getTypeChecker(),
            elementFactory: this.elementFactory
        });
        created.kind = kind;
        return created;
    }
    addElement(kind, node) {
        this.addElementAndParse(kind, node);
    }
    ;
    getParent() {
        return this.parent;
    }
    parse(node) {
        var _a, _b;
        this.name = (_b = (_a = node.name) === null || _a === void 0 ? void 0 : _a.escapedText) !== null && _b !== void 0 ? _b : "";
    }
}
exports.Element = Element;
